usuarios.component('usuarios.usuariosComponent', {
    templateUrl: 'usuarios/usuarios.html',
    controller: 'usuarios.usuariosController'
});

usuarios.controller('usuarios.usuariosController', ['$scope', 'coreLanguage', '$state', 'coreFb', '$timeout', '$filter', function($scope, $text, $state, $fb, $timeout, $filter) {
    const $ctrl = this;
    $scope.$text = $text;

    $ctrl.filter = {};
    $ctrl.perfis = [];

    const _getDominio=()=>{

        $ctrl.perfis = ['Aluno', 'Afiliado', 'Colaborador', 'Admin'];

    };

    const _tableRerender=()=>{
        let config = angular.copy($ctrl.tableObj);
        $ctrl.tableObj = null;
        $timeout(()=>{ $ctrl.tableObj = config; }, 100);
    };

    const _getUsuarios=()=>{
        $state.params.showGlobalLoading = true;
        $ctrl.tableObj.data = [];

        $fb.db.list('cad_usuarios', [{orderBy:['criacao.data', 'desc']},{limit:[100]}]).then(list=>{

            $ctrl.tableObj.data = list.map((item)=>{
                return {
                    fotoUrl: item.data.fotoUrl || 'assets/images/user-blank.jpg',
                    nome: item.data.nome || null,
                    telefone: item.data.telefone || null,
                    telefoneFormatado: item.data.telefone.ddi+' '+item.data.telefone.numero,
                    email: item.data.email || null,
                    dataCadastro: item.data.criacao.data.toDate(),
                    perfil: item.data.perfil || null,
                    nivelAcesso: item.data.nivelAcesso || null,
                    indice: `${item.data.nome || ''} ${item.data.telefone?.numero || ''} ${item.data.email || ''}`,
                    desabilitado: item.data.desabilitado || false,
                    docPath: item.path
                }
            });

            $state.params.showGlobalLoading = false;
            _tableRerender();
        });        
    };

    ////Modal usuario
    const _confirmUsuario=()=>{
        $ctrl.cfgUsuarios.isLoading=true;

        if($ctrl.cfgUsuarios.dados.docPath){
            if($ctrl.cfgUsuarios.dados.indice){ delete $ctrl.cfgUsuarios.dados.indice; }

            delete $ctrl.cfgUsuarios.dados.alteracao;
            delete $ctrl.cfgUsuarios.dados.criacao;

            $fb.db.update($ctrl.cfgUsuarios.dados.docPath, $ctrl.cfgUsuarios.dados).then((res)=>{
                $ctrl.cfgUsuarios.show = false;
                $ctrl.cfgUsuarios.isLoading=false;
                $state.reload();
            });
        }else{

            $fb.functions.invoke('webhook_log_fatura_interno', $ctrl.cfgUsuarios.dados).then(res=>{
                return $fb.db.list('cad_usuarios', [{where: ['email', '==', $ctrl.cfgUsuarios.dados.email]}]);  
            }).then(userList=>{
                return $fb.db.update(`cad_usuarios/${userList[0].id}`, {perfil: $ctrl.cfgUsuarios.dados.perfil, nivelAcesso: $ctrl.cfgUsuarios.dados.nivelAcesso });
            }).then(res=>{
                $ctrl.cfgUsuarios.show = false;
                $ctrl.cfgUsuarios.isLoading=false;
                $state.reload();
            });
        }
    };

    const _deleteUsuario=()=>{
        $ctrl.cfgUsuarios.isLoading=true;

        if($ctrl.cfgUsuarios.dados.docPath){
            $fb.db.del($ctrl.cfgUsuarios.dados.docPath).then((res)=>{
                $ctrl.cfgUsuarios.show = false;
                $ctrl.cfgUsuarios.isLoading=false;

                $state.reload();
            });
        }
    };

    const _blockUsuario=()=>{

        const c = confirm('Este aluno perderá o acesso ao conteúdo. Deseja continuar?');

        if(!c){
            return;
        }

        $ctrl.cfgUsuarios.isLoading=true;

        $fb.functions.invoke('crm_blockUser', {email: $ctrl.cfgUsuarios.dados.email})
        .then(res=>{
            $ctrl.cfgUsuarios.show = false;
            $ctrl.cfgUsuarios.isLoading=false;  

            $state.reload();
        });
    };

    const _editRegistroModal=(value)=>{
        $ctrl.cfgUsuarios.dados = angular.copy(value);
        $ctrl.cfgUsuarios.title = $text.editUser;
        $ctrl.cfgUsuarios.show = true;
    };

    $ctrl.setTableFilter=(value, field)=>{
        if(field==="search"){
            if(!value.length){
                delete $ctrl.filter.indice;
            }else{
                $ctrl.filter.indice = value;

                $ctrl.searchUsuarios(value);
            }
        }else{
            if(!!value){
                $ctrl.filter[field] = value;
            }else{
                delete $ctrl.filter[field];
            }
        }
    };

    $ctrl.addRegistroModal=()=>{
        /* return; */
        $ctrl.cfgUsuarios.dados = {telefone:{ddi:'55'}, perfil:'Aluno'};
        $ctrl.cfgUsuarios.title = $text.addUser;
        $ctrl.cfgUsuarios.show = true;
    };
    
    $ctrl.searchUsuarios=(search)=>{
        
        if(!search.includes('@')){
            return;
        }

        let hasOnList = $filter('filter')($ctrl.tableObj.data, {email:search}, true);

        if(hasOnList.length){
            return;
        }

        $fb.db.list('cad_usuarios', [{where: ['email', '==', search]}]).then(list=>{

            if(!list.length){
                return;
            }

            const serachList = list.map((item)=>{
                return {
                    fotoUrl: item.data.fotoUrl || 'assets/images/user-blank.jpg',
                    nome: item.data.nome || null,
                    telefone: item.data.telefone || null,
                    telefoneFormatado: item.data.telefone.ddi+' '+item.data.telefone.numero,
                    email: item.data.email || null,
                    dataCadastro: item.data.criacao.data.toDate(),
                    perfil: item.data.perfil || null,
                    nivelAcesso: item.data.nivelAcesso || null,
                    indice: `${item.data.nome || ''} ${item.data.telefone?.numero || ''} ${item.data.email || ''}`,
                    desabilitado: item.data.desabilitado || false,
                    docPath: item.path
                }
            });

            $ctrl.tableObj.data = $ctrl.tableObj.data.concat(serachList);

            _tableRerender();

        }).catch(err=>{
            console.error(err);
        });
    };

    $ctrl.cfgUsuarios = {
        show:false,
        dados: {},
        isLoading:false,
        confirm: _confirmUsuario,
        enableDelete:true,
        delete: _blockUsuario //_deleteUsuario
    };

    $ctrl.tableObj = {
        pageSize: 100,
        pageCount: 1,
        columns:[
            {title: '', key:'fotoUrl', type:'image', export:false},
            {title: $text.fullName.toUpperCase(), width:'25%', key:'nome', type:'text', export:true},
            {title: $text.email.toUpperCase(), key:'email', type:'text', export:true},
            {title: $text.phone.toUpperCase(), key:'telefoneFormatado', type:'text', export:true},
            {title: $text.regDate.toUpperCase(), key:'dataCadastro', type:'dateHour', export:true},
            {title: $text.profile.toUpperCase(), key:'perfil', type:'text', export:true}
        ],
        data:[],
        actions:{
            enable:{ edit:true, view:true, delete:false },
            edit: _editRegistroModal,
            view: _editRegistroModal
        },
        bulkActions:{
            enable: {delete:false},
            custom:[
                /* {
                    title: $text.changeWhatsapp,
                    icon: 'ph-whatsapp-logo',
                    action: _changeWhatsapp
                },
                {
                    title: $text.addTag,
                    icon: 'ph-tag',
                    action: _addTagModal
                } */
            ]
        }

    };

    $ctrl.$onInit = () => {
        $state.params.showGlobalLoading = false;

        _getDominio();
        _getUsuarios();
    }
    
}]);